import type { FaireProductEntity } from "../../entity_types/product";

export const p_3l9oc1zxoe: FaireProductEntity = {
  token: "p_3l9oc1zxoe",
  type: "product",
  name: "Organic Blueboon Blend, 12 oz",
  brandToken: "b_3angyj4q6y",
  brandName: "Sightglass Coffee Roasters",
  imageUrl:
    "https://cdn.faire.com/fastly/c1eebc0d77f167770bdf04dc3ad8872b83254b971461d4a408e1960c9830a7c6.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b82b58d129f78ef934797c027142575053e449026c4f9295fb856d7491b635ba.png",
    "https://cdn.faire.com/fastly/ca8b01d5d93fe920b18da5054645450e7cc243bccb09f4935f81fa2a32a058c6.png",
    "https://cdn.faire.com/fastly/e136cb9c51e8bf15ed806bbf4ecc8f46f7650e750620a3d644182d77c7023bf9.jpeg",
    "https://cdn.faire.com/fastly/e9d71021f2fdb4f03cb227ab97c8d57708fe82d6f307993b8951f4feef8aab94.jpeg",
    "https://cdn.faire.com/fastly/443a70ba743c00b079f7e372b3cc355b79a72c0c0266c0829510f4a5b1cf40d5.jpeg",
  ],
  priceDollars: 12.15,
  description:
    "Blueboon is our well-balanced, versatile blend that celebrates simple, approachable flavors of milk chocolate, citrus, and stone fruits. We change the components seasonally, so the coffees are always fresh and the balance of sweetness, body, and acidity is just right. This is our go-to Saturday morning cup.\n\nCCOF Certified Organic\n\nTaste Notes // Milk Chocolate, Mandarin, Honeysuckle\n\nRoast Profile // Light-Medium\n\nRecommended Brew Methods // V60, Chemex, Aeropress\n\nShelf Life // All our whole bean coffees are roasted fresh to order and stamped with the roast date. We encourage selling the coffee within 90 days of the roast date for optimal freshness and flavor.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:02:07.445Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
